__turbopack_context__.v({
  "className": "inter_dc274279-module__MTp2Sq__className",
});
